import { Stack, styled } from "@mui/material";
import { COLORS } from "constants/layout";

export const StyledInquiry = styled(Stack)(({ theme }) => ({
  padding: "8px 16px 16px",
  border: `1px solid ${COLORS.gray[200]}`,
  borderRadius: 8,
  backgroundColor: "#fff",
  cursor: "pointer",
  ".country-box": {
    padding: "2px 6px",
    height: 20,
    display: "inline-flex",
  },
  ".company-name": {
    span: {
      color: COLORS.green[600],
    },
  },
  ".creation": {
    span: {
      color: "var(--color)",
    },
  },
  ".customer-name": {
    color: "var(--sub-color)",
    width: "fit-content",
  },
  ".contact-btn": {
    color: "var(--color)",
    whiteSpace: "nowrap",
  },
  ".inquiry": {
    color: "var(--gray)",
    span: {
      color: "#475467",
      fontWeight: 600,
    },
  },
  ".send-quote": {
    color: "var(--color)",
    whiteSpace: "nowrap",
  },
  "&.is-seen": {
    backgroundColor: COLORS.gray[200],
  },
  ".btns": {
    button: {
      lineHeight: "20px",
    },
    a: {
      color: COLORS.green[600],
    },
    ".quote-btn": {
      // background: "#027A48",
    },
  },
  ".buyer-infos": {
    color: COLORS.gray[500],
    span: {
      color: COLORS.gray[900],
    },
    ".wrap": {
      marginTop: 8,
    },
    a: {
      color: COLORS.green[600],
    },
  },
  ".lock-icon": {
    width: 24,
    height: 24,
    backgroundColor: COLORS.yellow[50],
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  [theme.breakpoints.down("md")]: {
    padding: "8px",
  },
}));
